import React, { useState, useEffect } from 'react';
// import Menu from '../Menu/Menu';
import MenuLeft from '../Menu/MenuLeft';
import MenuRight from '../Menu/MenuRight';
import useEvent from '../../hooks/useEvent';
import settings from '../../data/settings';
import { useMediaQuery } from 'react-responsive';

const Main = () => {
  const [menuDirection, setMenuDirection] = useState('left');

  const isSmallScreen = useMediaQuery({ maxWidth: 640 });

  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  useEvent('open-sesame', handleOpen, true);

  // useEffect(() => {
  //   // setMenuDirection(settings.alignment.navigation);
  //   // setMenuDirection('left');
  // }, []);

  useEffect(() => {
    const direction = settings.alignment.navigation;
    document.documentElement.setAttribute('data-menu-direction', direction);
  }, []);

  //////////////////// Logic for handling logo on mobile phone ////////////////////////
  // useEffect(() => {
  //   if (isOpen && isSmallScreen) {
  //     const styleSheet = document.createElement('style');
  //     styleSheet.type = 'text/css';
  //     styleSheet.id = 'dynamic-styles';
  //     document.head.appendChild(styleSheet);

  //     styleSheet.innerText = `
  //     @media (max-width: 640px) {
  //       .wp-image-464{
  //         display: none !important;
  //       }
  //       .et_pb_image_0_tb_header .et_pb_image_wrap{
  //         display: none !important;
  //       }
  //       .et_pb_image .et_pb_image_wrap img[src*=".svg"] {
  //         display: none !important;
  //       }
  //       .et_pb_image_0_tb_header .et_pb_image_wrap img {
  //        display: none !important;
  //       }
  //     }
  //   `;
  //   } else {
  //     const styleSheet = document.createElement('style');
  //     styleSheet.type = 'text/css';
  //     styleSheet.id = 'dynamic-styles';
  //     document.head.appendChild(styleSheet);

  //     styleSheet.innerText = `
  //     @media (max-width: 640px) {
  //       .et_pb_image_0_tb_header .et_pb_image_wrap{
  //         display: block !important;
  //       }
  //       .et_pb_image .et_pb_image_wrap img[src*=".svg"] {
  //         display: block !important;
  //       }
  //       .et_pb_image_0_tb_header .et_pb_image_wrap img {
  //        display: block !important;
  //       }
  //     }
  //   `;
  //   }
  // }, [isOpen]);

  useEffect(() => {
    let styleSheet = document.getElementById('dynamic-styles');
    if (!styleSheet) {
      styleSheet = document.createElement('style');
      styleSheet.type = 'text/css';
      styleSheet.id = 'dynamic-styles';
      document.head.appendChild(styleSheet);
    }

    styleSheet.innerText =
      isOpen && isSmallScreen
        ? `
      @media (max-width: 640px) {
        .wp-image-464{
                  display: none !important;
                }
                .et_pb_image_0_tb_header .et_pb_image_wrap{
                  display: none !important;
                }
                .et_pb_image .et_pb_image_wrap img[src*=".svg"] {
                  display: none !important;
                }
                .et_pb_image_0_tb_header .et_pb_image_wrap img {
                 display: none !important;
                }
      }
    `
        : `
      @media (max-width: 640px) {
              .et_pb_image_0_tb_header .et_pb_image_wrap{
                  display: block !important;
                }
                .et_pb_image .et_pb_image_wrap img[src*=".svg"] {
                  display: block !important;
                }
                .et_pb_image_0_tb_header .et_pb_image_wrap img {
                 display: block !important;
                }
      }
    `;
  }, [isOpen, isSmallScreen]);

  return (
    <div className='flex flex-col content-center self-auto bg-slate-500'>
      <div className='w-full md:w-2/5' style={{ pointerEvents: 'none' }}>
        {settings.alignment.navigation === 'left' ? (
          <MenuLeft
            onRequestClose={handleClose}
            shouldCloseOnOverlayClick={true}
            onClick={handleClose}
            setIsOpen={setIsOpen}
            setIsClose={handleClose}
            isOpen={isOpen}
          />
        ) : (
          <MenuRight
            isOpen={isOpen}
            onRequestClose={() => {
              handleClose();
              setIsOpen(false);
            }}
            shouldCloseOnOverlayClick={true}
            onClick={handleClose}
            setIsOpen={setIsOpen}
            setIsClose={handleClose}
          />
        )}
      </div>
    </div>
  );
};

export default Main;
